import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

const styles = {
  text: {
    px: 2,
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default function NoRecordsTable({ configuration }) {
  return (
    <TableRow>
      <TableCell colSpan={configuration.fields.length + 2}>
        <Typography
          component="span"
          color="textSecondary"
          variant="h3"
          align="center"
          sx={styles.text}
        >
          No report history
        </Typography>
      </TableCell>
    </TableRow>
  );
}
